/**
 * Generated by orval v8.7.0 🍺
 * Do not edit manually.
 * Agentiq.Api | v1
 * OpenAPI spec version: 1.0.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  ActivateConnectorPackageRequest,
  ApiErrorResponse,
  ConnectorPackageActivationDto,
  ConnectorPackageDto,
  ConnectorPackageEditorLanguageResponse,
  ConnectorPackageExportDto,
  ConnectorPackageGeneratedArtifactsResponse,
  ConnectorPackageTestRunDto,
  ConnectorPackageTestScenarioDto,
  ConnectorPackageToolFormSchemaResponse,
  ConnectorPackageValidationResponse,
  CreateConnectorPackageFromTemplateRequest,
  ImportConnectorPackageRequest,
  RunConnectorPackageToolTestRequest,
  SaveConnectorPackageFileRequest,
  SaveConnectorPackageTestScenarioRequest
} from '../control-api.schemas';

import { orvalControlFetch } from '../../orval-fetcher';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



export const getGetApiConnectorPackagesUrl = () => {




  return `/api/connector-packages`
}

export const getApiConnectorPackages = async ( options?: RequestInit): Promise<ConnectorPackageDto[]> => {

  return orvalControlFetch<ConnectorPackageDto[]>(getGetApiConnectorPackagesUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetApiConnectorPackagesQueryKey = () => {
    return [
    `/api/connector-packages`
    ] as const;
    }


export const getGetApiConnectorPackagesQueryOptions = <TData = Awaited<ReturnType<typeof getApiConnectorPackages>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiConnectorPackages>>, TError, TData>>, request?: SecondParameter<typeof orvalControlFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiConnectorPackagesQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiConnectorPackages>>> = ({ signal }) => getApiConnectorPackages({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiConnectorPackages>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetApiConnectorPackagesQueryResult = NonNullable<Awaited<ReturnType<typeof getApiConnectorPackages>>>
export type GetApiConnectorPackagesQueryError = unknown


export function useGetApiConnectorPackages<TData = Awaited<ReturnType<typeof getApiConnectorPackages>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiConnectorPackages>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiConnectorPackages>>,
          TError,
          Awaited<ReturnType<typeof getApiConnectorPackages>>
        > , 'initialData'
      >, request?: SecondParameter<typeof orvalControlFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiConnectorPackages<TData = Awaited<ReturnType<typeof getApiConnectorPackages>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiConnectorPackages>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiConnectorPackages>>,
          TError,
          Awaited<ReturnType<typeof getApiConnectorPackages>>
        > , 'initialData'
      >, request?: SecondParameter<typeof orvalControlFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiConnectorPackages<TData = Awaited<ReturnType<typeof getApiConnectorPackages>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiConnectorPackages>>, TError, TData>>, request?: SecondParameter<typeof orvalControlFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetApiConnectorPackages<TData = Awaited<ReturnType<typeof getApiConnectorPackages>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiConnectorPackages>>, TError, TData>>, request?: SecondParameter<typeof orvalControlFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetApiConnectorPackagesQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}






export const getGetApiConnectorPackagesConnectorPackageIdUrl = (connectorPackageId: string,) => {




  return `/api/connector-packages/${connectorPackageId}`
}

export const getApiConnectorPackagesConnectorPackageId = async (connectorPackageId: string, options?: RequestInit): Promise<ConnectorPackageDto> => {

  return orvalControlFetch<ConnectorPackageDto>(getGetApiConnectorPackagesConnectorPackageIdUrl(connectorPackageId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetApiConnectorPackagesConnectorPackageIdQueryKey = (connectorPackageId: string,) => {
    return [
    `/api/connector-packages/${connectorPackageId}`
    ] as const;
    }


export const getGetApiConnectorPackagesConnectorPackageIdQueryOptions = <TData = Awaited<ReturnType<typeof getApiConnectorPackagesConnectorPackageId>>, TError = ApiErrorResponse>(connectorPackageId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiConnectorPackagesConnectorPackageId>>, TError, TData>>, request?: SecondParameter<typeof orvalControlFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiConnectorPackagesConnectorPackageIdQueryKey(connectorPackageId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiConnectorPackagesConnectorPackageId>>> = ({ signal }) => getApiConnectorPackagesConnectorPackageId(connectorPackageId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(connectorPackageId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiConnectorPackagesConnectorPackageId>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetApiConnectorPackagesConnectorPackageIdQueryResult = NonNullable<Awaited<ReturnType<typeof getApiConnectorPackagesConnectorPackageId>>>
export type GetApiConnectorPackagesConnectorPackageIdQueryError = ApiErrorResponse


export function useGetApiConnectorPackagesConnectorPackageId<TData = Awaited<ReturnType<typeof getApiConnectorPackagesConnectorPackageId>>, TError = ApiErrorResponse>(
 connectorPackageId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiConnectorPackagesConnectorPackageId>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiConnectorPackagesConnectorPackageId>>,
          TError,
          Awaited<ReturnType<typeof getApiConnectorPackagesConnectorPackageId>>
        > , 'initialData'
      >, request?: SecondParameter<typeof orvalControlFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiConnectorPackagesConnectorPackageId<TData = Awaited<ReturnType<typeof getApiConnectorPackagesConnectorPackageId>>, TError = ApiErrorResponse>(
 connectorPackageId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiConnectorPackagesConnectorPackageId>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiConnectorPackagesConnectorPackageId>>,
          TError,
          Awaited<ReturnType<typeof getApiConnectorPackagesConnectorPackageId>>
        > , 'initialData'
      >, request?: SecondParameter<typeof orvalControlFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiConnectorPackagesConnectorPackageId<TData = Awaited<ReturnType<typeof getApiConnectorPackagesConnectorPackageId>>, TError = ApiErrorResponse>(
 connectorPackageId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiConnectorPackagesConnectorPackageId>>, TError, TData>>, request?: SecondParameter<typeof orvalControlFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetApiConnectorPackagesConnectorPackageId<TData = Awaited<ReturnType<typeof getApiConnectorPackagesConnectorPackageId>>, TError = ApiErrorResponse>(
 connectorPackageId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiConnectorPackagesConnectorPackageId>>, TError, TData>>, request?: SecondParameter<typeof orvalControlFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetApiConnectorPackagesConnectorPackageIdQueryOptions(connectorPackageId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}






export const getPostApiConnectorPackagesFromTemplateUrl = () => {




  return `/api/connector-packages/from-template`
}

export const postApiConnectorPackagesFromTemplate = async (createConnectorPackageFromTemplateRequest: CreateConnectorPackageFromTemplateRequest, options?: RequestInit): Promise<ConnectorPackageDto> => {

  return orvalControlFetch<ConnectorPackageDto>(getPostApiConnectorPackagesFromTemplateUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      createConnectorPackageFromTemplateRequest,)
  }
);}




export const getPostApiConnectorPackagesFromTemplateMutationOptions = <TError = ApiErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiConnectorPackagesFromTemplate>>, TError,{data: CreateConnectorPackageFromTemplateRequest}, TContext>, request?: SecondParameter<typeof orvalControlFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof postApiConnectorPackagesFromTemplate>>, TError,{data: CreateConnectorPackageFromTemplateRequest}, TContext> => {

const mutationKey = ['postApiConnectorPackagesFromTemplate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiConnectorPackagesFromTemplate>>, {data: CreateConnectorPackageFromTemplateRequest}> = (props) => {
          const {data} = props ?? {};

          return  postApiConnectorPackagesFromTemplate(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostApiConnectorPackagesFromTemplateMutationResult = NonNullable<Awaited<ReturnType<typeof postApiConnectorPackagesFromTemplate>>>
    export type PostApiConnectorPackagesFromTemplateMutationBody = CreateConnectorPackageFromTemplateRequest
    export type PostApiConnectorPackagesFromTemplateMutationError = ApiErrorResponse

    export const usePostApiConnectorPackagesFromTemplate = <TError = ApiErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiConnectorPackagesFromTemplate>>, TError,{data: CreateConnectorPackageFromTemplateRequest}, TContext>, request?: SecondParameter<typeof orvalControlFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postApiConnectorPackagesFromTemplate>>,
        TError,
        {data: CreateConnectorPackageFromTemplateRequest},
        TContext
      > => {
      return useMutation(getPostApiConnectorPackagesFromTemplateMutationOptions(options), queryClient);
    }
    export const getPostApiConnectorPackagesImportUrl = () => {




  return `/api/connector-packages/import`
}

export const postApiConnectorPackagesImport = async (importConnectorPackageRequest: ImportConnectorPackageRequest, options?: RequestInit): Promise<ConnectorPackageDto> => {

  return orvalControlFetch<ConnectorPackageDto>(getPostApiConnectorPackagesImportUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      importConnectorPackageRequest,)
  }
);}




export const getPostApiConnectorPackagesImportMutationOptions = <TError = ApiErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiConnectorPackagesImport>>, TError,{data: ImportConnectorPackageRequest}, TContext>, request?: SecondParameter<typeof orvalControlFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof postApiConnectorPackagesImport>>, TError,{data: ImportConnectorPackageRequest}, TContext> => {

const mutationKey = ['postApiConnectorPackagesImport'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiConnectorPackagesImport>>, {data: ImportConnectorPackageRequest}> = (props) => {
          const {data} = props ?? {};

          return  postApiConnectorPackagesImport(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostApiConnectorPackagesImportMutationResult = NonNullable<Awaited<ReturnType<typeof postApiConnectorPackagesImport>>>
    export type PostApiConnectorPackagesImportMutationBody = ImportConnectorPackageRequest
    export type PostApiConnectorPackagesImportMutationError = ApiErrorResponse

    export const usePostApiConnectorPackagesImport = <TError = ApiErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiConnectorPackagesImport>>, TError,{data: ImportConnectorPackageRequest}, TContext>, request?: SecondParameter<typeof orvalControlFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postApiConnectorPackagesImport>>,
        TError,
        {data: ImportConnectorPackageRequest},
        TContext
      > => {
      return useMutation(getPostApiConnectorPackagesImportMutationOptions(options), queryClient);
    }
    export const getGetApiConnectorPackagesConnectorPackageIdExportUrl = (connectorPackageId: string,) => {




  return `/api/connector-packages/${connectorPackageId}/export`
}

export const getApiConnectorPackagesConnectorPackageIdExport = async (connectorPackageId: string, options?: RequestInit): Promise<ConnectorPackageExportDto> => {

  return orvalControlFetch<ConnectorPackageExportDto>(getGetApiConnectorPackagesConnectorPackageIdExportUrl(connectorPackageId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetApiConnectorPackagesConnectorPackageIdExportQueryKey = (connectorPackageId: string,) => {
    return [
    `/api/connector-packages/${connectorPackageId}/export`
    ] as const;
    }


export const getGetApiConnectorPackagesConnectorPackageIdExportQueryOptions = <TData = Awaited<ReturnType<typeof getApiConnectorPackagesConnectorPackageIdExport>>, TError = ApiErrorResponse>(connectorPackageId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiConnectorPackagesConnectorPackageIdExport>>, TError, TData>>, request?: SecondParameter<typeof orvalControlFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiConnectorPackagesConnectorPackageIdExportQueryKey(connectorPackageId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiConnectorPackagesConnectorPackageIdExport>>> = ({ signal }) => getApiConnectorPackagesConnectorPackageIdExport(connectorPackageId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(connectorPackageId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiConnectorPackagesConnectorPackageIdExport>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetApiConnectorPackagesConnectorPackageIdExportQueryResult = NonNullable<Awaited<ReturnType<typeof getApiConnectorPackagesConnectorPackageIdExport>>>
export type GetApiConnectorPackagesConnectorPackageIdExportQueryError = ApiErrorResponse


export function useGetApiConnectorPackagesConnectorPackageIdExport<TData = Awaited<ReturnType<typeof getApiConnectorPackagesConnectorPackageIdExport>>, TError = ApiErrorResponse>(
 connectorPackageId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiConnectorPackagesConnectorPackageIdExport>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiConnectorPackagesConnectorPackageIdExport>>,
          TError,
          Awaited<ReturnType<typeof getApiConnectorPackagesConnectorPackageIdExport>>
        > , 'initialData'
      >, request?: SecondParameter<typeof orvalControlFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiConnectorPackagesConnectorPackageIdExport<TData = Awaited<ReturnType<typeof getApiConnectorPackagesConnectorPackageIdExport>>, TError = ApiErrorResponse>(
 connectorPackageId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiConnectorPackagesConnectorPackageIdExport>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiConnectorPackagesConnectorPackageIdExport>>,
          TError,
          Awaited<ReturnType<typeof getApiConnectorPackagesConnectorPackageIdExport>>
        > , 'initialData'
      >, request?: SecondParameter<typeof orvalControlFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiConnectorPackagesConnectorPackageIdExport<TData = Awaited<ReturnType<typeof getApiConnectorPackagesConnectorPackageIdExport>>, TError = ApiErrorResponse>(
 connectorPackageId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiConnectorPackagesConnectorPackageIdExport>>, TError, TData>>, request?: SecondParameter<typeof orvalControlFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetApiConnectorPackagesConnectorPackageIdExport<TData = Awaited<ReturnType<typeof getApiConnectorPackagesConnectorPackageIdExport>>, TError = ApiErrorResponse>(
 connectorPackageId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiConnectorPackagesConnectorPackageIdExport>>, TError, TData>>, request?: SecondParameter<typeof orvalControlFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetApiConnectorPackagesConnectorPackageIdExportQueryOptions(connectorPackageId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}






export const getPutApiConnectorPackagesConnectorPackageIdFilesUrl = (connectorPackageId: string,) => {




  return `/api/connector-packages/${connectorPackageId}/files`
}

export const putApiConnectorPackagesConnectorPackageIdFiles = async (connectorPackageId: string,
    saveConnectorPackageFileRequest: SaveConnectorPackageFileRequest, options?: RequestInit): Promise<ConnectorPackageDto> => {

  return orvalControlFetch<ConnectorPackageDto>(getPutApiConnectorPackagesConnectorPackageIdFilesUrl(connectorPackageId),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      saveConnectorPackageFileRequest,)
  }
);}




export const getPutApiConnectorPackagesConnectorPackageIdFilesMutationOptions = <TError = ApiErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putApiConnectorPackagesConnectorPackageIdFiles>>, TError,{connectorPackageId: string;data: SaveConnectorPackageFileRequest}, TContext>, request?: SecondParameter<typeof orvalControlFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof putApiConnectorPackagesConnectorPackageIdFiles>>, TError,{connectorPackageId: string;data: SaveConnectorPackageFileRequest}, TContext> => {

const mutationKey = ['putApiConnectorPackagesConnectorPackageIdFiles'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putApiConnectorPackagesConnectorPackageIdFiles>>, {connectorPackageId: string;data: SaveConnectorPackageFileRequest}> = (props) => {
          const {connectorPackageId,data} = props ?? {};

          return  putApiConnectorPackagesConnectorPackageIdFiles(connectorPackageId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PutApiConnectorPackagesConnectorPackageIdFilesMutationResult = NonNullable<Awaited<ReturnType<typeof putApiConnectorPackagesConnectorPackageIdFiles>>>
    export type PutApiConnectorPackagesConnectorPackageIdFilesMutationBody = SaveConnectorPackageFileRequest
    export type PutApiConnectorPackagesConnectorPackageIdFilesMutationError = ApiErrorResponse

    export const usePutApiConnectorPackagesConnectorPackageIdFiles = <TError = ApiErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putApiConnectorPackagesConnectorPackageIdFiles>>, TError,{connectorPackageId: string;data: SaveConnectorPackageFileRequest}, TContext>, request?: SecondParameter<typeof orvalControlFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof putApiConnectorPackagesConnectorPackageIdFiles>>,
        TError,
        {connectorPackageId: string;data: SaveConnectorPackageFileRequest},
        TContext
      > => {
      return useMutation(getPutApiConnectorPackagesConnectorPackageIdFilesMutationOptions(options), queryClient);
    }
    export const getPostApiConnectorPackagesConnectorPackageIdValidateUrl = (connectorPackageId: string,) => {




  return `/api/connector-packages/${connectorPackageId}/validate`
}

export const postApiConnectorPackagesConnectorPackageIdValidate = async (connectorPackageId: string, options?: RequestInit): Promise<ConnectorPackageValidationResponse> => {

  return orvalControlFetch<ConnectorPackageValidationResponse>(getPostApiConnectorPackagesConnectorPackageIdValidateUrl(connectorPackageId),
  {
    ...options,
    method: 'POST'


  }
);}




export const getPostApiConnectorPackagesConnectorPackageIdValidateMutationOptions = <TError = ApiErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiConnectorPackagesConnectorPackageIdValidate>>, TError,{connectorPackageId: string}, TContext>, request?: SecondParameter<typeof orvalControlFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof postApiConnectorPackagesConnectorPackageIdValidate>>, TError,{connectorPackageId: string}, TContext> => {

const mutationKey = ['postApiConnectorPackagesConnectorPackageIdValidate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiConnectorPackagesConnectorPackageIdValidate>>, {connectorPackageId: string}> = (props) => {
          const {connectorPackageId} = props ?? {};

          return  postApiConnectorPackagesConnectorPackageIdValidate(connectorPackageId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostApiConnectorPackagesConnectorPackageIdValidateMutationResult = NonNullable<Awaited<ReturnType<typeof postApiConnectorPackagesConnectorPackageIdValidate>>>

    export type PostApiConnectorPackagesConnectorPackageIdValidateMutationError = ApiErrorResponse

    export const usePostApiConnectorPackagesConnectorPackageIdValidate = <TError = ApiErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiConnectorPackagesConnectorPackageIdValidate>>, TError,{connectorPackageId: string}, TContext>, request?: SecondParameter<typeof orvalControlFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postApiConnectorPackagesConnectorPackageIdValidate>>,
        TError,
        {connectorPackageId: string},
        TContext
      > => {
      return useMutation(getPostApiConnectorPackagesConnectorPackageIdValidateMutationOptions(options), queryClient);
    }
    export const getGetApiConnectorPackagesConnectorPackageIdGeneratedArtifactsUrl = (connectorPackageId: string,) => {




  return `/api/connector-packages/${connectorPackageId}/generated-artifacts`
}

export const getApiConnectorPackagesConnectorPackageIdGeneratedArtifacts = async (connectorPackageId: string, options?: RequestInit): Promise<ConnectorPackageGeneratedArtifactsResponse> => {

  return orvalControlFetch<ConnectorPackageGeneratedArtifactsResponse>(getGetApiConnectorPackagesConnectorPackageIdGeneratedArtifactsUrl(connectorPackageId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetApiConnectorPackagesConnectorPackageIdGeneratedArtifactsQueryKey = (connectorPackageId: string,) => {
    return [
    `/api/connector-packages/${connectorPackageId}/generated-artifacts`
    ] as const;
    }


export const getGetApiConnectorPackagesConnectorPackageIdGeneratedArtifactsQueryOptions = <TData = Awaited<ReturnType<typeof getApiConnectorPackagesConnectorPackageIdGeneratedArtifacts>>, TError = ApiErrorResponse>(connectorPackageId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiConnectorPackagesConnectorPackageIdGeneratedArtifacts>>, TError, TData>>, request?: SecondParameter<typeof orvalControlFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiConnectorPackagesConnectorPackageIdGeneratedArtifactsQueryKey(connectorPackageId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiConnectorPackagesConnectorPackageIdGeneratedArtifacts>>> = ({ signal }) => getApiConnectorPackagesConnectorPackageIdGeneratedArtifacts(connectorPackageId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(connectorPackageId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiConnectorPackagesConnectorPackageIdGeneratedArtifacts>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetApiConnectorPackagesConnectorPackageIdGeneratedArtifactsQueryResult = NonNullable<Awaited<ReturnType<typeof getApiConnectorPackagesConnectorPackageIdGeneratedArtifacts>>>
export type GetApiConnectorPackagesConnectorPackageIdGeneratedArtifactsQueryError = ApiErrorResponse


export function useGetApiConnectorPackagesConnectorPackageIdGeneratedArtifacts<TData = Awaited<ReturnType<typeof getApiConnectorPackagesConnectorPackageIdGeneratedArtifacts>>, TError = ApiErrorResponse>(
 connectorPackageId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiConnectorPackagesConnectorPackageIdGeneratedArtifacts>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiConnectorPackagesConnectorPackageIdGeneratedArtifacts>>,
          TError,
          Awaited<ReturnType<typeof getApiConnectorPackagesConnectorPackageIdGeneratedArtifacts>>
        > , 'initialData'
      >, request?: SecondParameter<typeof orvalControlFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiConnectorPackagesConnectorPackageIdGeneratedArtifacts<TData = Awaited<ReturnType<typeof getApiConnectorPackagesConnectorPackageIdGeneratedArtifacts>>, TError = ApiErrorResponse>(
 connectorPackageId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiConnectorPackagesConnectorPackageIdGeneratedArtifacts>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiConnectorPackagesConnectorPackageIdGeneratedArtifacts>>,
          TError,
          Awaited<ReturnType<typeof getApiConnectorPackagesConnectorPackageIdGeneratedArtifacts>>
        > , 'initialData'
      >, request?: SecondParameter<typeof orvalControlFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiConnectorPackagesConnectorPackageIdGeneratedArtifacts<TData = Awaited<ReturnType<typeof getApiConnectorPackagesConnectorPackageIdGeneratedArtifacts>>, TError = ApiErrorResponse>(
 connectorPackageId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiConnectorPackagesConnectorPackageIdGeneratedArtifacts>>, TError, TData>>, request?: SecondParameter<typeof orvalControlFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetApiConnectorPackagesConnectorPackageIdGeneratedArtifacts<TData = Awaited<ReturnType<typeof getApiConnectorPackagesConnectorPackageIdGeneratedArtifacts>>, TError = ApiErrorResponse>(
 connectorPackageId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiConnectorPackagesConnectorPackageIdGeneratedArtifacts>>, TError, TData>>, request?: SecondParameter<typeof orvalControlFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetApiConnectorPackagesConnectorPackageIdGeneratedArtifactsQueryOptions(connectorPackageId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}






export const getGetApiConnectorPackagesConnectorPackageIdEditorLanguageUrl = (connectorPackageId: string,) => {




  return `/api/connector-packages/${connectorPackageId}/editor-language`
}

export const getApiConnectorPackagesConnectorPackageIdEditorLanguage = async (connectorPackageId: string, options?: RequestInit): Promise<ConnectorPackageEditorLanguageResponse> => {

  return orvalControlFetch<ConnectorPackageEditorLanguageResponse>(getGetApiConnectorPackagesConnectorPackageIdEditorLanguageUrl(connectorPackageId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetApiConnectorPackagesConnectorPackageIdEditorLanguageQueryKey = (connectorPackageId: string,) => {
    return [
    `/api/connector-packages/${connectorPackageId}/editor-language`
    ] as const;
    }


export const getGetApiConnectorPackagesConnectorPackageIdEditorLanguageQueryOptions = <TData = Awaited<ReturnType<typeof getApiConnectorPackagesConnectorPackageIdEditorLanguage>>, TError = ApiErrorResponse>(connectorPackageId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiConnectorPackagesConnectorPackageIdEditorLanguage>>, TError, TData>>, request?: SecondParameter<typeof orvalControlFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiConnectorPackagesConnectorPackageIdEditorLanguageQueryKey(connectorPackageId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiConnectorPackagesConnectorPackageIdEditorLanguage>>> = ({ signal }) => getApiConnectorPackagesConnectorPackageIdEditorLanguage(connectorPackageId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(connectorPackageId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiConnectorPackagesConnectorPackageIdEditorLanguage>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetApiConnectorPackagesConnectorPackageIdEditorLanguageQueryResult = NonNullable<Awaited<ReturnType<typeof getApiConnectorPackagesConnectorPackageIdEditorLanguage>>>
export type GetApiConnectorPackagesConnectorPackageIdEditorLanguageQueryError = ApiErrorResponse


export function useGetApiConnectorPackagesConnectorPackageIdEditorLanguage<TData = Awaited<ReturnType<typeof getApiConnectorPackagesConnectorPackageIdEditorLanguage>>, TError = ApiErrorResponse>(
 connectorPackageId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiConnectorPackagesConnectorPackageIdEditorLanguage>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiConnectorPackagesConnectorPackageIdEditorLanguage>>,
          TError,
          Awaited<ReturnType<typeof getApiConnectorPackagesConnectorPackageIdEditorLanguage>>
        > , 'initialData'
      >, request?: SecondParameter<typeof orvalControlFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiConnectorPackagesConnectorPackageIdEditorLanguage<TData = Awaited<ReturnType<typeof getApiConnectorPackagesConnectorPackageIdEditorLanguage>>, TError = ApiErrorResponse>(
 connectorPackageId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiConnectorPackagesConnectorPackageIdEditorLanguage>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiConnectorPackagesConnectorPackageIdEditorLanguage>>,
          TError,
          Awaited<ReturnType<typeof getApiConnectorPackagesConnectorPackageIdEditorLanguage>>
        > , 'initialData'
      >, request?: SecondParameter<typeof orvalControlFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiConnectorPackagesConnectorPackageIdEditorLanguage<TData = Awaited<ReturnType<typeof getApiConnectorPackagesConnectorPackageIdEditorLanguage>>, TError = ApiErrorResponse>(
 connectorPackageId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiConnectorPackagesConnectorPackageIdEditorLanguage>>, TError, TData>>, request?: SecondParameter<typeof orvalControlFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetApiConnectorPackagesConnectorPackageIdEditorLanguage<TData = Awaited<ReturnType<typeof getApiConnectorPackagesConnectorPackageIdEditorLanguage>>, TError = ApiErrorResponse>(
 connectorPackageId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiConnectorPackagesConnectorPackageIdEditorLanguage>>, TError, TData>>, request?: SecondParameter<typeof orvalControlFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetApiConnectorPackagesConnectorPackageIdEditorLanguageQueryOptions(connectorPackageId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}






export const getGetApiConnectorPackagesConnectorPackageIdToolsToolNameFormSchemaUrl = (connectorPackageId: string,
    toolName: string,) => {




  return `/api/connector-packages/${connectorPackageId}/tools/${toolName}/form-schema`
}

export const getApiConnectorPackagesConnectorPackageIdToolsToolNameFormSchema = async (connectorPackageId: string,
    toolName: string, options?: RequestInit): Promise<ConnectorPackageToolFormSchemaResponse> => {

  return orvalControlFetch<ConnectorPackageToolFormSchemaResponse>(getGetApiConnectorPackagesConnectorPackageIdToolsToolNameFormSchemaUrl(connectorPackageId,toolName),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetApiConnectorPackagesConnectorPackageIdToolsToolNameFormSchemaQueryKey = (connectorPackageId: string,
    toolName: string,) => {
    return [
    `/api/connector-packages/${connectorPackageId}/tools/${toolName}/form-schema`
    ] as const;
    }


export const getGetApiConnectorPackagesConnectorPackageIdToolsToolNameFormSchemaQueryOptions = <TData = Awaited<ReturnType<typeof getApiConnectorPackagesConnectorPackageIdToolsToolNameFormSchema>>, TError = ApiErrorResponse>(connectorPackageId: string,
    toolName: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiConnectorPackagesConnectorPackageIdToolsToolNameFormSchema>>, TError, TData>>, request?: SecondParameter<typeof orvalControlFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiConnectorPackagesConnectorPackageIdToolsToolNameFormSchemaQueryKey(connectorPackageId,toolName);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiConnectorPackagesConnectorPackageIdToolsToolNameFormSchema>>> = ({ signal }) => getApiConnectorPackagesConnectorPackageIdToolsToolNameFormSchema(connectorPackageId,toolName, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(connectorPackageId && toolName), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiConnectorPackagesConnectorPackageIdToolsToolNameFormSchema>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetApiConnectorPackagesConnectorPackageIdToolsToolNameFormSchemaQueryResult = NonNullable<Awaited<ReturnType<typeof getApiConnectorPackagesConnectorPackageIdToolsToolNameFormSchema>>>
export type GetApiConnectorPackagesConnectorPackageIdToolsToolNameFormSchemaQueryError = ApiErrorResponse


export function useGetApiConnectorPackagesConnectorPackageIdToolsToolNameFormSchema<TData = Awaited<ReturnType<typeof getApiConnectorPackagesConnectorPackageIdToolsToolNameFormSchema>>, TError = ApiErrorResponse>(
 connectorPackageId: string,
    toolName: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiConnectorPackagesConnectorPackageIdToolsToolNameFormSchema>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiConnectorPackagesConnectorPackageIdToolsToolNameFormSchema>>,
          TError,
          Awaited<ReturnType<typeof getApiConnectorPackagesConnectorPackageIdToolsToolNameFormSchema>>
        > , 'initialData'
      >, request?: SecondParameter<typeof orvalControlFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiConnectorPackagesConnectorPackageIdToolsToolNameFormSchema<TData = Awaited<ReturnType<typeof getApiConnectorPackagesConnectorPackageIdToolsToolNameFormSchema>>, TError = ApiErrorResponse>(
 connectorPackageId: string,
    toolName: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiConnectorPackagesConnectorPackageIdToolsToolNameFormSchema>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiConnectorPackagesConnectorPackageIdToolsToolNameFormSchema>>,
          TError,
          Awaited<ReturnType<typeof getApiConnectorPackagesConnectorPackageIdToolsToolNameFormSchema>>
        > , 'initialData'
      >, request?: SecondParameter<typeof orvalControlFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiConnectorPackagesConnectorPackageIdToolsToolNameFormSchema<TData = Awaited<ReturnType<typeof getApiConnectorPackagesConnectorPackageIdToolsToolNameFormSchema>>, TError = ApiErrorResponse>(
 connectorPackageId: string,
    toolName: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiConnectorPackagesConnectorPackageIdToolsToolNameFormSchema>>, TError, TData>>, request?: SecondParameter<typeof orvalControlFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetApiConnectorPackagesConnectorPackageIdToolsToolNameFormSchema<TData = Awaited<ReturnType<typeof getApiConnectorPackagesConnectorPackageIdToolsToolNameFormSchema>>, TError = ApiErrorResponse>(
 connectorPackageId: string,
    toolName: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiConnectorPackagesConnectorPackageIdToolsToolNameFormSchema>>, TError, TData>>, request?: SecondParameter<typeof orvalControlFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetApiConnectorPackagesConnectorPackageIdToolsToolNameFormSchemaQueryOptions(connectorPackageId,toolName,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}






export const getPostApiConnectorPackagesConnectorPackageIdPublishUrl = (connectorPackageId: string,) => {




  return `/api/connector-packages/${connectorPackageId}/publish`
}

export const postApiConnectorPackagesConnectorPackageIdPublish = async (connectorPackageId: string, options?: RequestInit): Promise<ConnectorPackageDto> => {

  return orvalControlFetch<ConnectorPackageDto>(getPostApiConnectorPackagesConnectorPackageIdPublishUrl(connectorPackageId),
  {
    ...options,
    method: 'POST'


  }
);}




export const getPostApiConnectorPackagesConnectorPackageIdPublishMutationOptions = <TError = ApiErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiConnectorPackagesConnectorPackageIdPublish>>, TError,{connectorPackageId: string}, TContext>, request?: SecondParameter<typeof orvalControlFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof postApiConnectorPackagesConnectorPackageIdPublish>>, TError,{connectorPackageId: string}, TContext> => {

const mutationKey = ['postApiConnectorPackagesConnectorPackageIdPublish'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiConnectorPackagesConnectorPackageIdPublish>>, {connectorPackageId: string}> = (props) => {
          const {connectorPackageId} = props ?? {};

          return  postApiConnectorPackagesConnectorPackageIdPublish(connectorPackageId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostApiConnectorPackagesConnectorPackageIdPublishMutationResult = NonNullable<Awaited<ReturnType<typeof postApiConnectorPackagesConnectorPackageIdPublish>>>

    export type PostApiConnectorPackagesConnectorPackageIdPublishMutationError = ApiErrorResponse

    export const usePostApiConnectorPackagesConnectorPackageIdPublish = <TError = ApiErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiConnectorPackagesConnectorPackageIdPublish>>, TError,{connectorPackageId: string}, TContext>, request?: SecondParameter<typeof orvalControlFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postApiConnectorPackagesConnectorPackageIdPublish>>,
        TError,
        {connectorPackageId: string},
        TContext
      > => {
      return useMutation(getPostApiConnectorPackagesConnectorPackageIdPublishMutationOptions(options), queryClient);
    }
    export const getPostApiConnectorPackagesConnectorPackageIdActivateUrl = (connectorPackageId: string,) => {




  return `/api/connector-packages/${connectorPackageId}/activate`
}

export const postApiConnectorPackagesConnectorPackageIdActivate = async (connectorPackageId: string,
    activateConnectorPackageRequest: ActivateConnectorPackageRequest, options?: RequestInit): Promise<ConnectorPackageActivationDto> => {

  return orvalControlFetch<ConnectorPackageActivationDto>(getPostApiConnectorPackagesConnectorPackageIdActivateUrl(connectorPackageId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      activateConnectorPackageRequest,)
  }
);}




export const getPostApiConnectorPackagesConnectorPackageIdActivateMutationOptions = <TError = ApiErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiConnectorPackagesConnectorPackageIdActivate>>, TError,{connectorPackageId: string;data: ActivateConnectorPackageRequest}, TContext>, request?: SecondParameter<typeof orvalControlFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof postApiConnectorPackagesConnectorPackageIdActivate>>, TError,{connectorPackageId: string;data: ActivateConnectorPackageRequest}, TContext> => {

const mutationKey = ['postApiConnectorPackagesConnectorPackageIdActivate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiConnectorPackagesConnectorPackageIdActivate>>, {connectorPackageId: string;data: ActivateConnectorPackageRequest}> = (props) => {
          const {connectorPackageId,data} = props ?? {};

          return  postApiConnectorPackagesConnectorPackageIdActivate(connectorPackageId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostApiConnectorPackagesConnectorPackageIdActivateMutationResult = NonNullable<Awaited<ReturnType<typeof postApiConnectorPackagesConnectorPackageIdActivate>>>
    export type PostApiConnectorPackagesConnectorPackageIdActivateMutationBody = ActivateConnectorPackageRequest
    export type PostApiConnectorPackagesConnectorPackageIdActivateMutationError = ApiErrorResponse

    export const usePostApiConnectorPackagesConnectorPackageIdActivate = <TError = ApiErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiConnectorPackagesConnectorPackageIdActivate>>, TError,{connectorPackageId: string;data: ActivateConnectorPackageRequest}, TContext>, request?: SecondParameter<typeof orvalControlFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postApiConnectorPackagesConnectorPackageIdActivate>>,
        TError,
        {connectorPackageId: string;data: ActivateConnectorPackageRequest},
        TContext
      > => {
      return useMutation(getPostApiConnectorPackagesConnectorPackageIdActivateMutationOptions(options), queryClient);
    }
    export const getGetApiConnectorPackagesConnectorPackageIdTestScenariosUrl = (connectorPackageId: string,) => {




  return `/api/connector-packages/${connectorPackageId}/test-scenarios`
}

export const getApiConnectorPackagesConnectorPackageIdTestScenarios = async (connectorPackageId: string, options?: RequestInit): Promise<ConnectorPackageTestScenarioDto[]> => {

  return orvalControlFetch<ConnectorPackageTestScenarioDto[]>(getGetApiConnectorPackagesConnectorPackageIdTestScenariosUrl(connectorPackageId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetApiConnectorPackagesConnectorPackageIdTestScenariosQueryKey = (connectorPackageId: string,) => {
    return [
    `/api/connector-packages/${connectorPackageId}/test-scenarios`
    ] as const;
    }


export const getGetApiConnectorPackagesConnectorPackageIdTestScenariosQueryOptions = <TData = Awaited<ReturnType<typeof getApiConnectorPackagesConnectorPackageIdTestScenarios>>, TError = ApiErrorResponse>(connectorPackageId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiConnectorPackagesConnectorPackageIdTestScenarios>>, TError, TData>>, request?: SecondParameter<typeof orvalControlFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiConnectorPackagesConnectorPackageIdTestScenariosQueryKey(connectorPackageId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiConnectorPackagesConnectorPackageIdTestScenarios>>> = ({ signal }) => getApiConnectorPackagesConnectorPackageIdTestScenarios(connectorPackageId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(connectorPackageId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiConnectorPackagesConnectorPackageIdTestScenarios>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetApiConnectorPackagesConnectorPackageIdTestScenariosQueryResult = NonNullable<Awaited<ReturnType<typeof getApiConnectorPackagesConnectorPackageIdTestScenarios>>>
export type GetApiConnectorPackagesConnectorPackageIdTestScenariosQueryError = ApiErrorResponse


export function useGetApiConnectorPackagesConnectorPackageIdTestScenarios<TData = Awaited<ReturnType<typeof getApiConnectorPackagesConnectorPackageIdTestScenarios>>, TError = ApiErrorResponse>(
 connectorPackageId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiConnectorPackagesConnectorPackageIdTestScenarios>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiConnectorPackagesConnectorPackageIdTestScenarios>>,
          TError,
          Awaited<ReturnType<typeof getApiConnectorPackagesConnectorPackageIdTestScenarios>>
        > , 'initialData'
      >, request?: SecondParameter<typeof orvalControlFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiConnectorPackagesConnectorPackageIdTestScenarios<TData = Awaited<ReturnType<typeof getApiConnectorPackagesConnectorPackageIdTestScenarios>>, TError = ApiErrorResponse>(
 connectorPackageId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiConnectorPackagesConnectorPackageIdTestScenarios>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiConnectorPackagesConnectorPackageIdTestScenarios>>,
          TError,
          Awaited<ReturnType<typeof getApiConnectorPackagesConnectorPackageIdTestScenarios>>
        > , 'initialData'
      >, request?: SecondParameter<typeof orvalControlFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiConnectorPackagesConnectorPackageIdTestScenarios<TData = Awaited<ReturnType<typeof getApiConnectorPackagesConnectorPackageIdTestScenarios>>, TError = ApiErrorResponse>(
 connectorPackageId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiConnectorPackagesConnectorPackageIdTestScenarios>>, TError, TData>>, request?: SecondParameter<typeof orvalControlFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetApiConnectorPackagesConnectorPackageIdTestScenarios<TData = Awaited<ReturnType<typeof getApiConnectorPackagesConnectorPackageIdTestScenarios>>, TError = ApiErrorResponse>(
 connectorPackageId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiConnectorPackagesConnectorPackageIdTestScenarios>>, TError, TData>>, request?: SecondParameter<typeof orvalControlFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetApiConnectorPackagesConnectorPackageIdTestScenariosQueryOptions(connectorPackageId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}






export const getPutApiConnectorPackagesConnectorPackageIdTestScenariosUrl = (connectorPackageId: string,) => {




  return `/api/connector-packages/${connectorPackageId}/test-scenarios`
}

export const putApiConnectorPackagesConnectorPackageIdTestScenarios = async (connectorPackageId: string,
    saveConnectorPackageTestScenarioRequest: SaveConnectorPackageTestScenarioRequest, options?: RequestInit): Promise<ConnectorPackageTestScenarioDto> => {

  return orvalControlFetch<ConnectorPackageTestScenarioDto>(getPutApiConnectorPackagesConnectorPackageIdTestScenariosUrl(connectorPackageId),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      saveConnectorPackageTestScenarioRequest,)
  }
);}




export const getPutApiConnectorPackagesConnectorPackageIdTestScenariosMutationOptions = <TError = ApiErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putApiConnectorPackagesConnectorPackageIdTestScenarios>>, TError,{connectorPackageId: string;data: SaveConnectorPackageTestScenarioRequest}, TContext>, request?: SecondParameter<typeof orvalControlFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof putApiConnectorPackagesConnectorPackageIdTestScenarios>>, TError,{connectorPackageId: string;data: SaveConnectorPackageTestScenarioRequest}, TContext> => {

const mutationKey = ['putApiConnectorPackagesConnectorPackageIdTestScenarios'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putApiConnectorPackagesConnectorPackageIdTestScenarios>>, {connectorPackageId: string;data: SaveConnectorPackageTestScenarioRequest}> = (props) => {
          const {connectorPackageId,data} = props ?? {};

          return  putApiConnectorPackagesConnectorPackageIdTestScenarios(connectorPackageId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PutApiConnectorPackagesConnectorPackageIdTestScenariosMutationResult = NonNullable<Awaited<ReturnType<typeof putApiConnectorPackagesConnectorPackageIdTestScenarios>>>
    export type PutApiConnectorPackagesConnectorPackageIdTestScenariosMutationBody = SaveConnectorPackageTestScenarioRequest
    export type PutApiConnectorPackagesConnectorPackageIdTestScenariosMutationError = ApiErrorResponse

    export const usePutApiConnectorPackagesConnectorPackageIdTestScenarios = <TError = ApiErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putApiConnectorPackagesConnectorPackageIdTestScenarios>>, TError,{connectorPackageId: string;data: SaveConnectorPackageTestScenarioRequest}, TContext>, request?: SecondParameter<typeof orvalControlFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof putApiConnectorPackagesConnectorPackageIdTestScenarios>>,
        TError,
        {connectorPackageId: string;data: SaveConnectorPackageTestScenarioRequest},
        TContext
      > => {
      return useMutation(getPutApiConnectorPackagesConnectorPackageIdTestScenariosMutationOptions(options), queryClient);
    }
    export const getPostApiConnectorPackagesConnectorPackageIdToolTestsRunUrl = (connectorPackageId: string,) => {




  return `/api/connector-packages/${connectorPackageId}/tool-tests/run`
}

export const postApiConnectorPackagesConnectorPackageIdToolTestsRun = async (connectorPackageId: string,
    runConnectorPackageToolTestRequest: RunConnectorPackageToolTestRequest, options?: RequestInit): Promise<ConnectorPackageTestRunDto> => {

  return orvalControlFetch<ConnectorPackageTestRunDto>(getPostApiConnectorPackagesConnectorPackageIdToolTestsRunUrl(connectorPackageId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      runConnectorPackageToolTestRequest,)
  }
);}




export const getPostApiConnectorPackagesConnectorPackageIdToolTestsRunMutationOptions = <TError = ApiErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiConnectorPackagesConnectorPackageIdToolTestsRun>>, TError,{connectorPackageId: string;data: RunConnectorPackageToolTestRequest}, TContext>, request?: SecondParameter<typeof orvalControlFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof postApiConnectorPackagesConnectorPackageIdToolTestsRun>>, TError,{connectorPackageId: string;data: RunConnectorPackageToolTestRequest}, TContext> => {

const mutationKey = ['postApiConnectorPackagesConnectorPackageIdToolTestsRun'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiConnectorPackagesConnectorPackageIdToolTestsRun>>, {connectorPackageId: string;data: RunConnectorPackageToolTestRequest}> = (props) => {
          const {connectorPackageId,data} = props ?? {};

          return  postApiConnectorPackagesConnectorPackageIdToolTestsRun(connectorPackageId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostApiConnectorPackagesConnectorPackageIdToolTestsRunMutationResult = NonNullable<Awaited<ReturnType<typeof postApiConnectorPackagesConnectorPackageIdToolTestsRun>>>
    export type PostApiConnectorPackagesConnectorPackageIdToolTestsRunMutationBody = RunConnectorPackageToolTestRequest
    export type PostApiConnectorPackagesConnectorPackageIdToolTestsRunMutationError = ApiErrorResponse

    export const usePostApiConnectorPackagesConnectorPackageIdToolTestsRun = <TError = ApiErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiConnectorPackagesConnectorPackageIdToolTestsRun>>, TError,{connectorPackageId: string;data: RunConnectorPackageToolTestRequest}, TContext>, request?: SecondParameter<typeof orvalControlFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postApiConnectorPackagesConnectorPackageIdToolTestsRun>>,
        TError,
        {connectorPackageId: string;data: RunConnectorPackageToolTestRequest},
        TContext
      > => {
      return useMutation(getPostApiConnectorPackagesConnectorPackageIdToolTestsRunMutationOptions(options), queryClient);
    }
    export const getPostApiConnectorPackagesConnectorPackageIdTestScenariosScenarioIdRunUrl = (connectorPackageId: string,
    scenarioId: string,) => {




  return `/api/connector-packages/${connectorPackageId}/test-scenarios/${scenarioId}/run`
}

export const postApiConnectorPackagesConnectorPackageIdTestScenariosScenarioIdRun = async (connectorPackageId: string,
    scenarioId: string, options?: RequestInit): Promise<ConnectorPackageTestRunDto> => {

  return orvalControlFetch<ConnectorPackageTestRunDto>(getPostApiConnectorPackagesConnectorPackageIdTestScenariosScenarioIdRunUrl(connectorPackageId,scenarioId),
  {
    ...options,
    method: 'POST'


  }
);}




export const getPostApiConnectorPackagesConnectorPackageIdTestScenariosScenarioIdRunMutationOptions = <TError = ApiErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiConnectorPackagesConnectorPackageIdTestScenariosScenarioIdRun>>, TError,{connectorPackageId: string;scenarioId: string}, TContext>, request?: SecondParameter<typeof orvalControlFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof postApiConnectorPackagesConnectorPackageIdTestScenariosScenarioIdRun>>, TError,{connectorPackageId: string;scenarioId: string}, TContext> => {

const mutationKey = ['postApiConnectorPackagesConnectorPackageIdTestScenariosScenarioIdRun'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiConnectorPackagesConnectorPackageIdTestScenariosScenarioIdRun>>, {connectorPackageId: string;scenarioId: string}> = (props) => {
          const {connectorPackageId,scenarioId} = props ?? {};

          return  postApiConnectorPackagesConnectorPackageIdTestScenariosScenarioIdRun(connectorPackageId,scenarioId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostApiConnectorPackagesConnectorPackageIdTestScenariosScenarioIdRunMutationResult = NonNullable<Awaited<ReturnType<typeof postApiConnectorPackagesConnectorPackageIdTestScenariosScenarioIdRun>>>

    export type PostApiConnectorPackagesConnectorPackageIdTestScenariosScenarioIdRunMutationError = ApiErrorResponse

    export const usePostApiConnectorPackagesConnectorPackageIdTestScenariosScenarioIdRun = <TError = ApiErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiConnectorPackagesConnectorPackageIdTestScenariosScenarioIdRun>>, TError,{connectorPackageId: string;scenarioId: string}, TContext>, request?: SecondParameter<typeof orvalControlFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postApiConnectorPackagesConnectorPackageIdTestScenariosScenarioIdRun>>,
        TError,
        {connectorPackageId: string;scenarioId: string},
        TContext
      > => {
      return useMutation(getPostApiConnectorPackagesConnectorPackageIdTestScenariosScenarioIdRunMutationOptions(options), queryClient);
    }
